import { render, staticRenderFns } from "./Item60Effiwaste.vue?vue&type=template&id=01c21f09&scoped=true&"
import script from "./Item60Effiwaste.vue?vue&type=script&lang=js&"
export * from "./Item60Effiwaste.vue?vue&type=script&lang=js&"
import style0 from "./Item60Effiwaste.vue?vue&type=style&index=0&id=01c21f09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c21f09",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VFlex,VLayout})
